import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreSonarObjectsBulkPatchAsyncSlice } from './patch';

export const coreSonarObjectsBulkReducers = combineReducers({
	patch: getCoreSonarObjectsBulkPatchAsyncSlice.asyncReducers
});

export const coreSonarObjectsBulkWatchers = combineAllWatchers([
	getCoreSonarObjectsBulkPatchAsyncSlice.asyncWatchers
]);
